export const questionnaireTypes = {
  assetMgmt: "Asset Management",
  riskMgmt: "Risk Management",
};
